<script>
export default {
  name: "advertisementThree"
};
</script>

<template>
  <el-row style="padding: 40px 15px 40px 15px; background-color: #2D2D2D">
    <el-col :span="24" style="display: flex; justify-content: center">
      <img
        loading="lazy"
        src="../../assets/advertisement-3.jpg"
        style="width: 343px; height: 179px"
      />
    </el-col>
  </el-row>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/package/advertisementThree.vue